import { render, staticRenderFns } from "./Meeting.Right.ChangeLayout.vue?vue&type=template&id=31bb6360&scoped=true&"
import script from "./Meeting.Right.ChangeLayout.vue?vue&type=script&lang=js&"
export * from "./Meeting.Right.ChangeLayout.vue?vue&type=script&lang=js&"
import style0 from "./Meeting.Right.ChangeLayout.vue?vue&type=style&index=0&id=31bb6360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb6360",
  null
  
)

export default component.exports